import { BoardViewType } from "app/types";
import React from "react";
import ColumnTaskCreate from "./ColumnTaskCreate";
import { TicketGroup } from "../../types";

interface AddTicketProps {
  readonly type: BoardViewType;
  readonly onCancel: () => void;
 readonly group: TicketGroup;
}
const Index: React.FC<AddTicketProps> = ({
  type,
  onCancel,
  group,
}) => {
  return (
    <div>
      {type === BoardViewType.KANBAN ? (
        <ColumnTaskCreate
          onCancel={onCancel}
          group={group}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default Index;
